import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    id_cotizacion: null,
    vr_fasecolda: 0,
    vr_tucarro: 0,
    vr_olx: 0,
    vr_depreciacion: 0,
    vr_publicacion: 0,
    vr_sugerido: 0,
    vr_retoma: 0,
    vr_minimo: 0,
    vr_precio_final: 0,
    anoModal: null,
    titleModal: null,
    depreciacion_table: [
        {
            ano: '2020',
            porcentaje: 0,
            porcentaje_2: 0.8500
        },
        {
            ano: '2019',
            porcentaje: 0.8500,
            porcentaje_2: 0.7225
        },
        {
            ano: '2018',
            porcentaje: 0.7650,
            porcentaje_2: 0.6503
        },
        {
            ano: '2017',
            porcentaje: 0.6885,
            porcentaje_2: 0.5852
        },
        {
            ano: '2016',
            porcentaje: 0.6197,
            porcentaje_2: 0.5267
        },
        {
            ano: '2015',
            porcentaje: 0.5577,
            porcentaje_2: 0.4740
        },
        {
            ano: '2014',
            porcentaje: 0.5019,
            porcentaje_2: 0.4266
        },
        {
            ano: '2013',
            porcentaje: 0.4517,
            porcentaje_2: 0.3840
        },
        {
            ano: '2012',
            porcentaje: 0.4066,
            porcentaje_2: 0.3456
        },
        {
            ano: '2011',
            porcentaje: 0.3659,
            porcentaje_2: 0.3110
        },
        {
            ano: '2010',
            porcentaje: 0.3293,
            porcentaje_2: 0.2799
        }
    ]
};
const mutations = {
    updateField,
    updateCotizacion: (state, payload) =>{
        if(!payload.fichatecnica.id_cotizacion){
            state.vr_fasecolda = payload.modelorel.avaluo.vr_fasecolda+'000';
        }else{
            var { cotizacion, precio_publicacion } = payload.fichatecnica;
            state.vr_fasecolda = cotizacion.vr_fasecolda;
            state.vr_tucarro = cotizacion.vr_tucarro;
            state.vr_olx = cotizacion.vr_olx; 
            state.vr_depreciacion = cotizacion.vr_depreciacion;
            /** */
            state.vr_publicacion = cotizacion.vr_publicacion;
            state.vr_sugerido = cotizacion.vr_sugerido;
            state.vr_retoma = cotizacion.vr_retoma; 
            state.vr_minimo = cotizacion.vr_minimo;
            state.vr_precio_final = precio_publicacion;
        }
    },
    updateAnoModal: (state, payload) => {
        state.anoModal = payload;
    },
    updateTitleModal: (state, payload) => {
        state.titleModal = payload.marca+' '+payload.linea+' '+payload.modelo+' '+payload.version;
    },
    updateDepreciacion: (state, payload) =>{
        state.vr_depreciacion = payload;
    },
    removeDepreciacion: (state) =>{
        state.vr_depreciacion = 0;
    }
};

const getters = {
    getField,
    getDepreciacionPercent(state){
        var objDepreciacion = _.find(state.depreciacion_table, (depreciacion) => { 
            return depreciacion.ano == state.anoModal; 
        });
        if(objDepreciacion === undefined){
            objDepreciacion = {
                ano: state.anoModal,
                porcentaje: 0.3293,
                porcentaje_2: 0.2799
            }
        }
        return objDepreciacion;
    }
};

const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
